import React, { createContext, useState, useContext } from 'react';

// Create the Loader Context
const FullScreenLoaderContext = createContext();

// Custom hook to use loader state
export const useFullScreenLoader = () => useContext(FullScreenLoaderContext);

// Loader Provider component that wraps your app
export const FullScreenLoaderProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState(null);

  return (
    <FullScreenLoaderContext.Provider value={{ loading, loadingText,  setLoading, setLoadingText }}>
      {children}
    </FullScreenLoaderContext.Provider>
  );
};
